import { ApiResponse, Service } from "@roc/feature-app-core";

export abstract class InsuranceAgentService extends Service {
  abstract getInsuranceAgentGrid(zipCode: string, page: number, pageSize: number, sortDir: string, sortBy: string, filters: object): Promise<ApiResponse>
}